export const CONTACT = {
  phone: "+91 98258 81617",
  phoneRaw: "+919825881617",
  whatsapp: "919825881617",
  email: "info@kkassociates.in",
  address:
    "Above Shree Titali Beauty Parlour, Umiya Chowk, Jalaram Plot-1, University Road, Rajkot – 360005",
  hours: "Mon – Sat • 10:00 AM to 7:00 PM",
  mapEmbed:
    "https://www.google.com/maps?q=Umiya+Chowk+Jalaram+Plot+1+University+Road+Rajkot+360005&hl=en&z=16&output=embed",
  mapLink: "https://maps.app.goo.gl/hiygfjnEKZfoG1XeA",
};

export const BRAND = {
  name: "KK Associates",
  tagline: "Chartered Accountants • Tax • Business Consultancy",
  city: "Rajkot",
};

// Build a WhatsApp deep-link with a pre-filled message
export const waLink = (message) =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(message)}`;
